import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      style={{
        // background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
        color: "#fff",
        background: "#3a3933fc",
      }}
      className="pt-5"
    >
      <Container>
        <Row className=" gx-5 footer-row">

          {/* Company Info */}
          <Col lg={4} md={6}>
            <div className="footer-box">
              <img src="new4.png" width="110" alt="logo" className="mb-3" />

              <p className="footer-contant">
                Gayatri Infotech is an Education Class. Our experts serve a wide
                range of software development like web design, graphic design,
                web development, mobile development, SEO services, digital
                marketing, e-commerce solutions, custom application development,
                and more.
              </p>
            </div>
          </Col>

          {/* Quick Links */}
          <Col lg={2} md={6}>
            <div className="footer-box">
              <h6 className="fw-bold mb-3 footer-heading">Quick Links</h6>

              <ul className="list-unstyled">
                <li>
                  <Link to="/" className="footer-link d-block py-1">
                    Home
                  </Link>
                </li>

                <li>
                  <Link to="/Aboutpage" className="footer-link d-block py-1">
                    About Us
                  </Link>
                </li>

                <li>
                  <Link to="/CourseDetails" className="footer-link d-block py-1">
                    Courses
                  </Link>
                </li>
                <li>
                  <Link to="/BlogPage" className="footer-link d-block py-1">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/ContactPage" className="footer-link d-block py-1">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="footer-link d-block py-1">
                    Terms of Service
                  </Link>
                </li>

                <li>
                  <Link to="/privacy" className="footer-link d-block py-1">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </Col>

          {/* Our Courses */}
          <Col lg={3} md={6}>
            <div className="footer-box">
              <h6 className="fw-bold mb-3 footer-heading">Our Courses</h6>
              <ul className="list-unstyled">
                {["Web Design", "Web Development", "Product Management", "Marketing", "Graphic Design"].map((service, i) => (
                  <li key={i}>
                    <a href="#" className="footer-link d-block py-1">
                      {service}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Col>

          {/* Contact Info */}
          <Col lg={3} md={6}>
            <div className="footer-box">
              <h6 className="fw-bold mb-3 footer-heading">Contact Us</h6>

              <p className="small mb-2 footer-contact">
                9/4, Shri Markendaya Yantramag Dharak Society, Near New WIT College,
                Next to Upahar Bakery lane, Solapur - 413006.
              </p>

              <p className="small mb-1">
                <strong>Phone:</strong> +1 5589 55488 55
              </p>

              <p className="small mb-3">
                <strong>Email:</strong> info@example.com
              </p>

              {/* Social Icons */}
              <div className="d-flex gap-3 mt-2">
                <a href="#" className="social-icon"><FaTwitter /></a>
                <a href="#" className="social-icon"><FaFacebookF /></a>
                <a href="#" className="social-icon"><FaInstagram /></a>
                <a href="#" className="social-icon"><FaLinkedinIn /></a>
              </div>
            </div>
          </Col>

        </Row>
        <hr className="border-light opacity-25" />

        {/* Bottom Row */}
        <Row className="text-center">
          <Col>
            <p className="mb-1 small">
              © {new Date().getFullYear()} <strong>Gayatri Infotech</strong> — All Rights Reserved
            </p>
            <p className="small opacity-75">
              Designed  by{" "}
              <a href="#" className="text-decoration-none footer-name fw-bold">
                Gayatri Infotech
              </a>
            </p>
          </Col>
        </Row>
      </Container>

      {/* Extra CSS for hover effect */}

    </footer>
  );
};

export default Footer;
